export const environment = {
  production: true,
  isMockEnabled: true, // You have to switch this, when your real back-end is done
  codigoSistema: '0001',
  timeToRefreshToken: 3000,
  channel: 'web',
  merchantId: '522591303',
  endPointJS: "https://static-content-qas.vnforapps.com/v2/js/checkout.js?qa=true",
  siteKey: '6Le3d78ZAAAAANndqU27yzGL6PdEdY_ZQO4hAaO0',
  privateKey: 'pk_live_daEBZRv2O9ShQPxc',
  social: {
    FACEBOOK_ID: '313635033369228',
    GOOGLE_ID: '742815218794-7gf5c9eslqbvalftjipq1vu3097qtd34.apps.googleusercontent.com'
  },

  jwt: {
    audience: 'DefaultAudience',
    issuer: 'DefaultIssuer'
  },

  /*WEB SERVICES*/
  api: {
    WS_IT: {
      url: 'https://wssec.danper.com:8991/WS_IT/api',
      basicAuthorization: {
        username: 'VnITApp',
        password: '975318642'
      }
    },
    WS_ECOMMERCE: {
      url: 'https://wssec.danper.com:8991/WS_SD/api',
      basicAuthorization: {
        username: 'VnSDApp',
        password: '975318642'
      }
    },
    WS_TARIFARIO: {
      url: 'https://waetitaxi.azurewebsites.net/WS_TX/api/tarifa'
    },
    WS_VISANET: {
      url: 'https://wssec.danper.com:8991/WS_VN/api',
      basicAuthorization: {
        username: 'VnVNApp',
        password: '975318642'
      }
    }
  }
};